<template>
  <div class="content self_content self_c">
    <headNav
      color="#56AC9A"
      :back="true"
      :title="window_c['Restaurant details']"
    />
    <div
      class="self_body self_b"
      :style="'min-height:' + window_.self_body_h + 'px;'"
    >
      <!-- :height="window_.restaurantInfoImg_h" -->
      <van-image
        class="rest_img"
        fit="cover"
        :src="info.restaurantInfoImg"
      >
        <template v-slot:loading>
          <van-loading
            type="spinner"
            size="20"
          />
        </template>
        <template v-slot:error>
          <van-image
            fit="cover"
            :src="require('../../assets/icon/default.png')"
          />
        </template>
      </van-image>
      <div
        v-if="info.perCapita"
        class="self_perCapita self_line"
      >
        {{ info.perCapita }}
      </div>
      <div
        v-if="info.restaurantCate"
        class="self_line self_restaurantCates"
      >
        <div
          v-for="(item, index) in strSplit(info.restaurantCate, ',')"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <div class="self_workingTime_box">
        <div
          v-if="info.workingTime"
          class="self_workingTime"
          v-html="strToHtml(info.workingTime)"
        ></div>
        <!-- 订座 -->
        <div
          v-if="info.orderseatService == 1"
          class="self_reservation self_bg_color"
          v-on:click="getMaxSize"
        >
          <!-- v-if="1 == 2" -->
          {{ window_c["Reservation"] }}
        </div>
        <!-- 外送 -->
        <div
          v-if="info.menuService == 1"
          class="self_reservation self_bg_color"
          @click="breakPage"
        >
          <!-- v-if="1 == 2" -->
          {{ window_c["Delivery"] }}
        </div>
      </div>
      <div
        v-if="info.restaurantDesc2"
        class="self_restaurant_title self_line"
      >
        {{ window_c["Restaurant details"] }}
      </div>
      <div
        v-if="info.restaurantDesc2"
        class="self_restaurantDesc2"
        v-html="info.restaurantDesc2"
      ></div>

      <van-image
        class="self_mapImg"
        fit="cover"
        :src="mapImageUrl"
        :height="window_.mapImageUrl_h"
      >
        <template v-slot:loading>
          <van-loading
            type="spinner"
            size="20"
          />
        </template>
        <template v-slot:error>
          <img
            fit="cover"
            :src="require('../../assets/icon/default.png')"
            :height="window_.mapImageUrl_h"
          />
        </template>
      </van-image>
      <div class="self_foot">
        <img
          class="self_phone self_bg_color"
          src="../../assets/dizhi.png"
        />
        <div
          @click="goMap"
          v-html="setAddressText(info.addressDetail)"
        ></div>
        <div class="self_foot-line"></div>
        <a
          class="self_cl_phone"
          :href="'tel:' + info.restaurantPhone"
        ><img
            class="self_phone self_bg_color"
            src="../../assets/dianhua.png"
          /></a>
      </div>
    </div>
  </div>
</template>
<script>
import headNav from "@/components/headNav";
import { getRestaurantInfoById, getMaxSize } from "@/js/api";
import lang_ from "@/js/locales";
import util from "@/js/util";
import Base64 from "@/js/base64";

export default {
  data () {
    return {
      window_c: {
        lang: "hk",
        "Restaurant details": "餐廳詳情",
        Reservation: "訂座",
        Delivery: "外賣",
        Loading: "加載中..."
      },
      window_: {
        self_body_h: 0,
        restaurantInfoImg_h: 0,
        mapImageUrl_w: 0,
        mapImageUrl_h: 0,
        wordTimeBox_w: 0,
        reservation_w: 0
      },
      info: {},
      mapImageUrl: "",
      is_height: 667
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this, () => {
      this.getRestaurantInfo();
    });
    this.init_window();
  },
  mounted () {
    this.init_lang();
    this.is_height = window.innerHeight;
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      var lang = localStorage.foodStoryLanguage;
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      if (lang == "en") {
        // 英文
        this.window_.wordTimeBox_w = w - 100;
        this.window_.reservation_w = 90;
      } else {
        this.window_.wordTimeBox_w = w - 50;
        this.window_.reservation_w = 40;
      }
      window_c["Reservation"] = lang_.t("Reservation");
      window_c["Delivery"] = lang_.t("Delivery");
      window_c["Loading"] = lang_.t("Loading");
      // window_c['Restaurant details'] = lang_.t('Restaurant details');
    },
    init_window () {
      var self = this;
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      self.window_.self_body_h = h - 46;
      self.window_.restaurantInfoImg_h = w / 2;
    },
    getRestaurantInfo () {
      var self = this;
      let id = util.getQueryParams(this.$route.params)[1];
      getRestaurantInfoById({ id }).then(res => {
        if (res.code == "1") {
          this.info = res.data;
          self.window_c["Restaurant details"] = res.data.restaurantName;
          this.initMap();
        }
      });
    },
    initMap () {
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      var width = w;
      var height = parseInt(width / 1.7);
      var language = "zh";
      if (localStorage.foodStoryLanguage == "en") {
        language = "en";
      }
      if (util.ISNULL(this.info.mapX) || util.ISNULL(this.info.mapY)) {
        this.mapImageUrl = "";
      } else {
        var mapURL =
          "http://maps.google.com/maps/api/staticmap?key=AIzaSyCujUc1iFYa8GBWthpm3IOJp6_rxcBjI-I&language=" +
          language +
          "&scale=2&";
        var mapImageUrl =
          mapURL +
          "center=" +
          this.info.mapX + // X
          "," +
          this.info.mapY + // Y
          "&zoom=17&size=" +
          parseInt(width) +
          "x" +
          parseInt(height) +
          "&format=jpg&mobile=true&maptype=roadmap&markers=size:mid|color:red|label:" +
          "A" +
          "|" +
          this.info.mapX +
          "," +
          this.info.mapY +
          "&sensor=false";

        this.mapImageUrl = mapImageUrl;
      }
      this.window_.mapImageUrl_w = width;
      this.window_.mapImageUrl_h = height;
    },
    goMap () {
      var self = this;
      let brandId = util.getBrandId(this);
      let maps =
        self.info.mapX +
        "_^" +
        self.info.mapY +
        "_^" +
        encodeURIComponent(self.info.restaurantName);
      this.$router.push({
        name: "map",
        params: {
          arg: util.setQueryParams([brandId, maps])
        }
      });
    },
    strToHtml (str) {
      // return
      console.log(str);
      try {
        var s = str.replace(/\/r\/n/g, "<br/>");
        console.log(s);
        return s;
      } catch (e) {
        return str;
      }
    },
    strSplit (str, t) {
      try {
        return str.split(t + "");
      } catch (e) {
        return [];
      }
    },
    /**
     * 更改 商家地址格式
     * @param {Object} e
     */
    setAddressText (e) {
      console.log(e);
      if (util.ISNULL(e)) {
        return "";
      }
      e = e.replace(/  /g, "</br>"); // 將兩個 空格 改為 換行
      return e;
    },
    getMaxSize () {
      var self = this;
      // self.window_.loadShow = true;
      this.$toast.loading({
        message: self.window_c["Loading"],
        forbidClick: true,
        duration: 0,
        loadingType: "spinner"
      });
      let id = util.getQueryParams(this.$route.params)[1];
      getMaxSize({ restaurantId: id }).then(res => {
        if (res.code == "1") {
          console.log(res);
          sessionStorage.foodStoryMaxSize = JSON.stringify(res.data);
          sessionStorage.foodStoryRestId = id;
          // self.window_.loadShow = false
          self.$toast.clear();
          self.$router.push({
            name: "reservation",
            params: {
              arg: util.setQueryParams([util.getBrandId(this)])
            }
          });
        }
      });
    },
    // 跳轉頁面
    breakPage () {
      let href = "";
      let userinfo = util.userInfo.get(this);
      let localObj = JSON.parse(userinfo);
      let localLang = localStorage.getItem("foodStoryLanguage");
      // 哈希base64加密
      let baseUrl = Base64.ba_encode({
        menutype: 1,
        type: 1,
        shopid: this.info.id,
        memberId: localObj.memberId,
        phone: localObj.phone,
        lang: localLang == "en" ? "en" : "zh-hk"
      });
      // 判斷域名地址
      if (window.location.host && window.location.host.startsWith("hktest")) {
        //有端口號
        href = `${window.location.origin}/ricepon-web/app/index.html?arg=${baseUrl}`;
      } else {
        //無
        href = `https://${window.location.hostname}/ricepon-web/app/index.html?arg=${baseUrl}`;
      }
      window.open(href, "__blank");
    }
  },
  components: {
    headNav
  }
};
</script>
<style scoped>
.self_content {
  padding-top: 46px !important;
}

.self_body {
  display: flex;
  flex-direction: column;
  /* min-height:calc(100% - 46px) !important; */
}

.self_perCapita {
  font-size: 14px;
  padding: 3px 10px;
  background-color: #fff;
}

.self_restaurantCates {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #fff;
  flex-wrap: wrap;
}

.self_restaurantCates div {
  border: 1px solid #979797;
  border-radius: 5px;
  margin: 10px 0 0 10px;
  font-size: 13px;
  color: #979797;
  padding: 3px 5px;
}

.self_workingTime_box {
  /* display: flex; */
  border-bottom: 5px solid #f5f5f5;
}

.self_workingTime {
  padding: 10px;
  font-size: 14px;
  width: 100%;
}
.self_reservation {
  width: calc(100% - 20px);
  height: 40px;
  margin: 20px auto;
  /*  width: 40px;
  height: 25px; */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgb(86, 172, 154);
  border-radius: 5px;
  /* margin-top: 10px; */
  /*  margin-left: auto;
  margin-right: 10px; */
}

.self_restaurant_title {
  font-size: 16px;
  padding: 10px;
}

.self_restaurantDesc2 {
  padding: 10px;
}

.self_mapImg {
  margin-top: auto;
  display: table;
}

.self_foot {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 49px;
}
.self_foot img {
  width: 25px;
  height: 25px;
}
.self_foot-line {
  width: 1px;
  height: 23px;
  background-color: #ccc;
  margin-left: auto;
}

.rest_img {
  display: table;
}

.self_cl_phone {
  display: flex;
  align-items: center;
}

.self_phone {
  margin: 0 10px;
}

.self_line {
  position: relative;
  padding-bottom: 10px;
}

.self_line:after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  background-color: #f5f5f5;
}

.pc_content .self_b {
  padding: 0;
}
.app_content,
.self_content {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/brand/restaurant_details.vue